import { DeviceType, PairingState } from 'src/Libs/installations/types'
import { WeekTimeValueModel } from '../../Libs/home-power-station/models/home-power-station.model'
import { DeviceLinkModel } from 'src/Libs/installations/models/device-link.model'
import { Days } from '@e3dc-react/shell/Libs/date/types'
import { Installation } from 'src/Libs/installations/models/installation.model'

export interface StorageForm {
  id?: number
  deviceLinkId?: number
  wiring?: string
  gridDisconnector?: boolean
  sgrUsedPower?: number
  sgrCooldown?: boolean
  peakPowerPv?: number
  pvInverterStringCount?: number
  pvInverterCountryStandard?: string
  emergencyPowerCheckPartialGridFailure?: boolean
  emergencyPowerDelayInSeconds?: number
  emergencyPowerCapacityReserve?: number
  installedPVCapacity?: number
  agreedConnectionLoad?: number
  powerReductionFrom?: number
  powerReduction?: 'Pv Leistung' | 'Anschlusswirkleistung'
  reactivePowerSpecification?: true
  reactivePowerSpecificationValue?: number
  reactivePowerSpecificationVariant?: 'induktiv' | 'Kapazitiv'
  frequencyReverseProtectionLower?: number
  frequencyReverseProtectionUpper?: number
  voltageProtectionAvg?: number
  voltageFuseProtection?: number
  voltageDropProtection?: number
  // createdAt: string
  // updatedAt: string
  // deletedAt: string
}

export type InterfaceControllerDevice = 'XEM900' | 'HTC320H'

export type EmsProductTypeValue =
  | 'S10 E'
  | 'S10 SE'
  | 'S10 E Compact'
  | 'S10 X Compact'
  | 'S10 E Pro'
  | 'S10 SP40'
  | 'S10 X Pro'
  | 'S20 X Pro'
  | 'S10 Mini'
  | 'S10 X'
  | 'S10 E Pro Compact'
  | 'Quattroporte'
  | 'S10 X/S10 X COMPACT' /* currently we cannot decide by SN which one it is, so we get a combined type */
  | 'SFM'
  | 'S10 Xplus'
  | 'S10 Xflex'
  | 'one'
  | 'qntm'
  | 'XEM'
  | 'XEM1200'
  | 'XCM'
  | 'FR2'
  | 'XHM'

export enum EmsProductType {
  s10_e = 'S10 E',
  s10_se = 'S10 SE',
  s10_e_compact = 'S10 E Compact',
  s10_x_compact = 'S10 X Compact',
  s10_e_pro = 'S10 E Pro',
  s10_sp40 = 'S10 SP40',
  s10_x_pro = 'S10 X Pro',
  s20_x_pro = 'S20 X Pro',
  s10_mini = 'S10 Mini',
  s10_x = 'S10 X',
  s10_e_pro_compact = 'S10 E Pro Compact',
  quattroporte = 'Quattroporte',
  s10_x_S10_x_compact = 'S10 X/S10 X COMPACT',
  farm_manager = 'SFM',
  s10_xplus = 'S10 Xplus',
  s10_xflex = 'S10 Xflex',
  one = 'one',
  qntm = 'qntm',
  xem1200 = 'XEM1200',
}

export interface EmcConfigModel {
  id: number
  deviceLinkId: number
  useCT: boolean
  ratioCT: string
}

export interface MonitoringSubDevices {
  meters?: MonitoringSubDevice[]
  tempSensors?: MonitoringSubDevice[]
}

export interface SubDevices {
  monitoring: MonitoringSubDevices
  controllers: ControllerSubDevice[]
  controlled: ControlledSubDevice[]
}

export type DeletingStatus = 'waiting' | 'deleting' | 'deleted' | 'failed'

export interface SubDevicesRaw {
  monitoring: MonitoringSubDevices
  controllers: ControllerSubDevice[]
  controlled: ControlledSubDeviceRaw[]
}

export type ControlledDeviceMedia = 'ModbusTCP' | 'EEBus'
export type SubDeviceMedia = 'Modbus' | 'ModbusRTU' | 'ModbusTCP' | 'EM400' | 'EEBus'
export type ControllerSubDeviceMedia = 'Storage' | 'ModbusRTU'
export type MonitoringDeviceType = 'HVAC' | 'PVExtern' //| 'WhiteGoods' | 'Dryer' | 'Root'  | 'Wallbox'
export const MonitoringDeviceTypeArray = ['HVAC', 'PVExtern'] //| 'WhiteGoods' | 'Dryer' | 'Root'  | 'Wallbox'
export type MonitoringSubDevice = {
  id: number
  deviceName: string
  media: SubDeviceMedia
  mediaParameters: Record<string, number | ''>
  pairingState?: 'required' | 'not required' | 'paired'
  deviceStatus?: DeviceStatus
} & ({ deviceType: 'HVAC'; typeParameters: HvacParameters } | { deviceType: 'PVExtern'; typeParameters: PvExternParameters })

type DeviceStatus = 'ok' | 'warning' | 'error' | 'unknown'
export interface PvExternParameters {
  peakPower?: number
}

export interface HvacParameters {
  nominalPower?: number
}

export type ControllerOutputConfiguration = 'SGReady' | 'o1-o1'
export type OutputType = 'HVAC' | 'PVExtern'
export interface IoOutputModel {
  id?: number
  typeParameters: IoTypeParameters
  deviceType: OutputType
  features: 'SGReady1' | 'SGReady2' | 'IndependentOutput'
  linkedDeviceId?: number
}

export interface IoTypeParameters {
  nominalPower?: number
  peakPower?: number
}

//Io Interfaces
export interface ControllerSubDevice {
  id?: number
  type: 'IOController'
  deviceName: string
  media: ControlledDeviceMedia | ControllerSubDeviceMedia
  mediaParameters?: Record<string, string | number>
  outputConfiguration: ControllerOutputConfiguration
  controllerDevice?: InterfaceControllerDevice
  outputs: IoOutputModel[]
  pairingState?: PairingState
  deviceStatus?: DeviceStatus
}

export interface DayTimeEnergyModel {
  daytime?: number
  minEnergy: number //daytime is seconds after midnight so 3600 = 01:00
}

//evse
export interface ControlledSubDeviceRaw {
  id: number
  deviceName: string
  media: ControlledDeviceMedia
  mediaParameters: {
    localId: string | null
    macAddress: string | null
  }
  type: 'Evse' | 'HVAC' | 'WhiteGoods'
  pairingState?: PairingState
  deviceStatus?: DeviceStatus
  parameters: {
    protection?: number
    priority: number
    prioritySum?: number
    activated: boolean
    sunMode: {
      activated: boolean
      chargingStrategy: 'Delayed' | 'Immediate' | 'Disabled'
      parameterList?: DayTimeEnergyModel[]
      // chargingStrategyPerDayInSec: '36000;0;0;0;0;0;0'
      // charginStrategyPerDayMinEnergyInKWh: '3;0;0;0;0;0;0'
      holdingTimeInMin: number
    }
  }
}
export interface ControlledSubDevice {
  id: number
  deviceName: string
  media: ControlledDeviceMedia
  mediaParameters: {
    localId: string | null
    macAddress: string | null
  }
  type: 'Evse' | 'HVAC' | 'WhiteGoods'
  parameters: ControlledSubDeviceParameters
  pairingState?: PairingState
  deviceStatus?: DeviceStatus
}

export interface ControlledSubDeviceParameters {
  protection?: number
  priority: number
  prioritySum?: number
  activated: boolean
  sunMode: ControlledSubDeviceSunMode
}

export interface ControlledSubDeviceSunMode {
  activated: boolean
  chargingStrategy: 'Delayed' | 'Immediate' | 'Disabled'
  parameterList: WeekTimeValueModel[]
  // chargingStrategyPerDayInSec: '36000;0;0;0;0;0;0'
  // charginStrategyPerDayMinEnergyInKWh: '3;0;0;0;0;0;0'
  holdingTimeInMin: number
}

export interface DeviceLinkForm<T extends DeviceLinkConfig> {
  // createdAt?: string
  // deletedAt?: string
  deviceId?: string
  deviceShortUuid?: string
  deviceType: DeviceType
  deviceName?: string
  controllerDevice?: InterfaceControllerDevice
  id?: number
  media?: ControlledDeviceMedia | ControllerSubDeviceMedia
  pairingState?: PairingState
  isEmsMaster: boolean
  config?: T
}

export interface StorageConfigModel {
  id: number
  deviceLinkId: number
  wiring: string
  gridDisconnector: boolean
  sgrUsedPower: number
  sgrCooldown: boolean
  peakPowerPv: number
  pvInverterStringCount: number
  pvInverterCountryStandard: string
  emergencyPowerCheckPartialGridFailure: boolean
  emergencyPowerDelayInSeconds: number
  emergencyPowerCapacityReserve: number
  installedPVCapacity: number
  agreedConnectionLoad: number
  powerReductionFrom: number
  powerReduction: 'Pv Leistung' | 'Anschlusswirkleistung'
  reactivePowerSpecification: true
  reactivePowerSpecificationValue: number
  reactivePowerSpecificationVariant: 'induktiv' | 'Kapazitiv'
  frequencyReverseProtectionLower: number
  frequencyReverseProtectionUpper: number
  votageProtectionAvg: number
  voltageFuseProtection: number
  voltageDropProtection: number
  createdAt: string
  updatedAt: string
  deletedAt: string
}

export type HandleDeviceLinkChange<T extends DeviceLinkConfig> = (name: keyof DeviceLinkForm<T>, value: unknown) => void
export type HandleDeviceLinkConfigChange<T extends DeviceLinkConfig> = (name: keyof T, value: unknown) => void

export type DeviceLinkConfig = StorageForm | EMCForm | EvseForm //todo evse + emc
export interface EvseForm {
  param?: string
}

export interface EMCForm {
  useCT?: boolean
  ratioCT?: string
}

export enum ElectricalGridPhaseType {
  ONE = 1,
  THREE = 3,
}

export const parseElectricalGridPhaseType = (value: string): ElectricalGridPhaseType | undefined => {
  const intValue = Number.parseInt(value)
  if (intValue === 1) return ElectricalGridPhaseType.ONE
  if (intValue === 3) return ElectricalGridPhaseType.THREE
  return undefined
}

export type ReactivePowerType = 'Fix CosPhi' | 'CosPhi(P)' | 'Q(U)'
export type ActivePowerType = 'Deactivated' | 'P(U) Type A' | 'P(U) Type B'

export interface StorageConfigFormModel {
  name?: string
  // aus installation config
  eegValue?: number | ''
  eegDerateAtConnectedPower?: boolean
  eegConnectedPower?: number | ''
  emsWeatherRegulatedChargeEnabled?: boolean
  emsWallboxEnforcePowerAssignment?: boolean
  emsBatteryBeforeCarMode?: boolean
  emsBatteryToCarMode?: boolean
  emsOperatingRangeAuto?: boolean
  emsMaxChargePower?: number | ''
  emsMaxDischargePower?: number | ''
  emsDischargeStartPower?: number | ''
  emsPowersaveEnabled?: boolean
  peakPowerPv?: number | ''

  //aus devicelinks/id/config storage
  sgrUsedPower?: number | ''
  sgrCooldown?: boolean
  pvInverterStringCount?: number | ''
  frequencyReverseProtectionLower?: number | ''
  frequencyReverseProtectionUpper?: number | ''
  emergencyPowerCheckPartialGridFailure?: boolean
  emergencyPowerDelayInSeconds?: number | ''
  emergencyPowerCapacityReserve?: number | ''
}

export interface EvseConfigFormModel {
  selfconsumptionUseCase?: boolean
  coordinateChargingUseCase?: boolean
  phaseImbalance?: boolean
  phaseImbalanceValue?: number | null
}
export interface GeneralInformationDataFormModel {
  phaseCount?: 1 | 3
  mainFuse?: number
  mainFuseDerated?: number
  useCT?: boolean
  ratioCT?: string

  // phaseType?: ElectricalGridPhaseType
  // preFuse?: number
  // connectionDerated?: number
  // powerMeterType?: string
  // active?: boolean
  // eegValue?: number
  // eegDerateAtConnectedPower?: boolean
  // eegConnectedPower?: number
  // sgrUsedPower?: number
  // sgrCooldown?: boolean
  // emsWeatherRegulatedChargeEnabled?: boolean
  // emsBatteryBeforeCarMode?: boolean
  // emsBatteryToCarMode?: boolean
  // emsWallboxEnforcePowerAssignment?: boolean
  // emsMaxChargePower?: number
  // emsMaxDischargePower?: number
  // emsDischargeStartPower?: number
  // emsPowersaveEnabled?: boolean
  // selfconsumptionUseCase?: boolean
  // coordinateChargingUseCase?: boolean
  // phaseImbalance?: boolean
  // phaseImbalanceValue?: number
}
export interface InstallationConfigModel {
  preFuse: number
  connectionDerated: number
  powerMeterType: string
  active: boolean
  mainFuse: number
  mainFuseDerated: number
  eegValue: number
  eegActive: boolean
  eegDerateAtConnectedPower: boolean
  eegConnectedPower: number
  phaseCount: 1 | 3
  emsWeatherRegulatedChargeEnabled: boolean
  emsBatteryBeforeCarMode: boolean
  emsBatteryToCarMode: boolean
  emsOperatingRangeAuto?: boolean
  emsWallboxEnforcePowerAssignment: boolean
  emsMaxChargePower: number
  emsMaxDischargePower: number
  emsDischargeStartPower: number
  emsPowersaveEnabled: boolean
  selfconsumptionUseCase: boolean
  coordinateChargingUseCase: boolean
  phaseImbalance: boolean
  phaseImbalanceValue: number
  peakPowerPv: number
}

export interface IdlePeriodForm {
  mode: 'charge' | 'discharge'
  from: 'string'
  to: 'string'
  days: Days
}

export interface TariffModelRaw {
  from: string
  price: string
  start: string
  end: string
  weekday: string // "0,1,4,8" weil Backend doof ist.
}
export interface TariffModel {
  from?: string
  price?: number
  start?: string
  end?: string | null
  weekday?: Days
}

export interface InstallationLocationForm {
  countryCode: string
  streetName: string
  streetNumber: string
  city: string
  zip: string
  timezone: string
}

export interface WizardData {
  installation: Installation
  deviceLinks: Array<DeviceLinkModel>
}

/* TODO: consolidate this with the newly added DTO objects in Libs/installation-rights-management/dto/... */
export interface AccountLinkModel {
  id: number
  userName: string
  firstName: string
  lastName: string
  installationId: number
  accountId: string
  accountType: string
  accountSource: string
  role: 'owner' | 'installer' | 'user' | 'sales'
  inviteId: string
  startAt: string
  stopAt: string
  permissionType: AccessRight
  storagePermissionType: AccessRight
  createdAt: string
  updatedAt: string
  deletedAt: string
}

export interface AccountInvitationModel {
  token: string
  installationId: number
  projectName?: string
  accountId: string //email of the user
  inviteType: 'invite' | 'handover'
  url: string
  createdAt: string
  updatedAt: string
}

export enum AccessRightOptions {
  ro = 'ro',
  rw = 'rw',
  noAccess = 'no-access',
  pending = 'pending',
  empty = '',
  blocked = 'blocked',
}

/** 'ro' | 'rw' | 'no-access' | 'pending' | '' | blocked */
export type AccessRight = `${AccessRightOptions}`

export interface AccessManagementModel {
  id: string
  email: string
  firstName?: string
  lastName?: string
  validUntil?: string
  permissionType: AccessRight
  storagePermissionType: AccessRight
  invitationAccepted: boolean
  owner: boolean
  token?: string
}

export interface AccountLinkFetchModel {
  id: number[]
  installationId: number[]
  accountId: string[]
  accountType: string[]
  accountSource: string[]
  role: string[]
  inviteId: string[]
  startAt: string[]
  stopAt: string[]
  createdAt: string[]
  updatedAt: string[]
  deletedAt: string[]
  [key: string]: any[] //eslint-disable-line
}

export type { ApiAccountRole as AccountRole } from 'src/Libs/api'

export interface NetworkScanModel {
  prefix: string
  serialno: number
  uid: string
  shortUid: string
  cName: string
}

export interface EvseScanModel {
  firstScanComplete: boolean
  isPartialResult: boolean
  results: Array<{
    mac: string
    deviceName: string
    ip: string
  }>
}
